import { create } from 'zustand';

interface EmiInformationState {
  previousPath: string;
  setPreviousPath: (path: string) => void;
  showEMISection: boolean;
  setShowEMISection: (show: boolean) => void;
  emiInformation?: {
    bankId: string;
    bankEmiId: string;
  };
  setEmiInformation: (emiInfo: { bankId: string; bankEmiId: string }) => void;
}

export const useEmiStore = create<EmiInformationState>((set) => ({
  previousPath: '',
  setPreviousPath: (path) => set({ previousPath: path }),

  showEMISection: false,
  setShowEMISection: (show) => set({ showEMISection: show }),

  emiInformation: undefined,
  setEmiInformation: (emiInfo) => set({ emiInformation: emiInfo }),
}));
